export default __webpack_public_path__ + "static/media/tick.02e01573.svg";